// extracted by css-extract-rspack-plugin
export default {"cls1":"AuthorsCard-cls1_thF","cls2":"AuthorsCard-cls2_Pwi AuthorsCard-cls1_thF"};